require('./creditCancelSuccess.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
//helpers
const { getLastNChars } = require('utilities/stringHelper');

class CreditCancelSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.handleGoToPass = this.handleGoToPass.bind(this);
        this.handleGoToLoansAndMortgages = this.handleGoToLoansAndMortgages.bind(this);
    }

    getAccountAliasAndNumber(immCredit) {
        const accountNumber = getLastNChars(immCredit.get('iban'), 4, '*', 4);
        return `${immCredit.get('alias')} ${accountNumber}`;
    }

    handleGoToLoansAndMortgages() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleGoToPass() {
        this.props.history.push('/myprofile/transfers/pass');
    }

    render() {
        const { immCredit } = this.props;
        const labelLoansMortgages = <FormattedText value="creditCancelSuccess-goLoansMortgages" />;
        const labelPass = <FormattedText value="creditCancelSuccess-goToPass" />;

        let goToPassButton;
        let messageSecondPart;

        const accountAliasAndNumber = this.getAccountAliasAndNumber(immCredit);

        if (immCredit.getIn(['available', 'amount']) < 0) {
            goToPassButton = (
                <div className="credit-cancel-success__extra-button">
                    <OKButton id="" modifier="link-complementary" onClick={this.handleGoToPass}>
                        {labelPass}
                    </OKButton>
                </div>
            );

            messageSecondPart = (
                <FormattedText
                    className="credit-cancel-success__message-second-part"
                    value="creditCancelSuccess-messagePart2"
                />
            );
        }

        return (
            <OKSectionBox className="credit-cancel-success">
                <article className="credit-cancel-success__container">
                    <i className="wizard-success-step__success-icon">
                    </i>
                    <div className="credit-cancel-success__content">
                        <OKBoxTitle value={
                            <div>
                                <FormattedText className="" value="creditCancelSuccess-messagePart1" />
                                <span className="credit-cancel-success__value">{accountAliasAndNumber}</span>
                                {messageSecondPart}
                            </div>
                        } />
                        <footer className="credit-cancel-success__footer">
                            <div className="pull-right">
                                {goToPassButton}
                                <OKButton id="" modifier="link-complementary" onClick={this.handleGoToLoansAndMortgages}>
                                    {labelLoansMortgages}
                                </OKButton>
                            </div>
                        </footer>
                    </div>
                </article>
            </OKSectionBox>
        );
    }
}

CreditCancelSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immCredit: PropTypes.object,
};

module.exports = withRouter(CreditCancelSuccess);
